<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-input style="width:200px;"
                  placeholder="请输入名称"
                  prefix-icon="el-icon-search"
                  clearable
                  @clear="bindGrid"
                  v-model="searchdata" @keyup.enter.native="bindGrid">
        </el-input>
        <el-checkbox v-model="isoverendtime" @change="bindGrid">过期租户</el-checkbox>
        <el-button type="warning" v-on:click="add">新增</el-button>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight()"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        width="50"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="unitguid"
        align="left" header-align="center"
        label="licence" >
      </el-table-column>
      <el-table-column
        prop="tenantname"
        align="left" header-align="center"
        label="名称" >
      </el-table-column>
      <el-table-column
        prop="website"
        label="网址"
        align="left">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="appurl"-->
        <!--label="接口地址"-->
        <!--align="left" header-align="center">-->
        <!--<template slot-scope="scope">-->
          <!--{{JSON.parse(scope.row.appguid)[0].appurl}}-->
        <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column
        prop="platformlicensing"
        label="年费" header-align="center"
        align="left" width="100">
      </el-table-column>
      <el-table-column
        prop="enddatetime"
        label="有效期" header-align="center"
        width="100"
        align="left">
        <template slot-scope="scope">
          <span>{{format(scope.row.enddatetime)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="contactname"
        label="管理员"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="contactphone"
        label="手机号"
        align="center" width="200">
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="添加日期"
        width="200"
        align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handlePermission(scope.$index, scope.row)">授权
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <ManageTenantEdit ref="manageTenantEdit" @bindGuid="bindGrid"></ManageTenantEdit>
    <el-dialog title="租户权限授权" :visible.sync="permissionDialogVisible" custom-class="medium-dialog" center
               :close-on-click-modal="false" :append-to-body="true" width="600px">
      <div v-if="currentTenantName" style="margin-bottom: 15px; font-weight: bold; color: #409EFF;">
        租户：{{ currentTenantName }}
      </div>
      <div v-for="(group, gIndex) in permissionGroups" :key="gIndex" style="margin-bottom: 15px;">
        <div style="font-weight: bold; margin-bottom: 8px; color: #606266; border-bottom: 1px solid #ebeef5; padding-bottom: 5px;">
          {{ group.groupName }}
        </div>
        <el-checkbox-group v-model="selectedPermissions">
          <el-checkbox v-for="(perm, pIndex) in group.permissions" :key="pIndex" :label="perm.key" style="margin-right: 15px; margin-bottom: 8px;">
            {{ perm.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="savePermissions" :loading="savingPermission">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {sysmanageList, parameterMaintainList, sysupdateparacontent} from '@/api/sysmanage/sysmanage'
  import {updateData, getLogListData} from '@/api/set/handlelog';
  import ManageTenantEdit from './ManageTenantEdit'

  export default {
    name: 'ManageTenant',
    data() {
      return {
        dialogFormVisible: false,
        isoverendtime:false,
        searchdata: "",
        dname: "",
        fdpath: "",
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        permissionDialogVisible: false,
        currentTenantId: '',
        currentTenantName: '',
        selectedPermissions: [],
        savingPermission: false,
        permissionRecord: null,
        permissionGroups: [
          {
            groupName: '开单环节',
            permissions: [
              { key: 'defaultsffreight', label: '默认选择顺丰快递' },
              { key: 'useai', label: '启用AI开单' },
              { key: 'stockwith', label: '备货商品合并在一张订单' },
              { key: 'wholesalemarket', label: '现片扫码面对面出库' },
              { key: 'framewholesale', label: '镜架下单面对面出库' },
              { key: 'frameeditprice', label: '镜架下单允许修改单价' },
            ]
          },
          {
            groupName: '订单确认环节',
            permissions: [
              { key: 'order200print', label: '订单确认状态下能打印订单' },
              { key: 'linecreditNobuy', label: '信用额度不足的情况下允许采购和通知仓库' },
              { key: 'fengongscangku', label: '总部处理分公司订单时，默认选中分公司仓库' },
              { key: 'quickNotifyStore', label: '允许使用批量处理（快速通知仓库）' },
            ]
          }, {
            groupName: '加工环节',
            permissions: [
              { key: 'machinefinishing', label: '根据关联销售单的状态处理加工单' },
              { key: 'machiningrefund', label: '加工单打印/加工后允许申请退款' }
            ]
          },
          {
            groupName: '仓库环节',
            permissions: [
              { key: 'binallocation', label: '启用发货库位管理' },
              { key: 'showboxsticker', label: '打印盒贴' },
              { key: 'printbacksticker', label: '打印标签' },
              { key: 'printoutstock', label: '打印缺货单' },
              { key: 'printpickup', label: '打印拣货单' },
              { key: 'cangku_jianhuo', label: '拣货管理' },
              { key: 'supodderrequired', label: '发货时GY.NO 必填' },
              { key: 'xinyoneduprint', label: '无信用额度不允许打印' },
              { key: 'badoutaudit', label: '启用坏件库出库审核' },
            ]
          },
          {
            groupName: '采购环节',
            permissions: [
              { key: 'auditbuyorder', label: '采购单需要审核' },
            ]
          },
          {
            groupName: '财务核算',
            permissions: [
              { key: 'CashAccountresult', label: '应收款中包含现金户' },
              { key: 'showallpuhuo', label: '应收款中铺货显示全部明细' },
              { key: 'SingleReconciliation', label: '启用单笔订单对账功能' },
              { key: 'kehushowshicj', label: '结算-客户 导出中增加市场价' },
              { key: 'sendStatement', label: '启用发送对账单功能' },
            ]
          },
          {
            groupName: '系统级功能',
            permissions: [
              { key: 'showbichart', label: '开通BI' },
              { key: 'chunhuo', label: '开通存货功能' },
              { key: 'hidewatermark', label: '系统背景不显示水印' },
            ]
          }
        ],
      }
    },
    methods: {
      //添加
      add() {
        this.$refs.manageTenantEdit.show()
      },
      //格式化日期
      format(date) {
        let newDate = new Date(date);
        return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()
      },
      //权限授权
      handlePermission(index, row) {
        this.currentTenantId = row.unitguid;
        this.currentTenantName = row.tenantname;
        this.selectedPermissions = [];
        this.savingPermission = false;
        this.permissionRecord = null;
        this.permissionDialogVisible = true;
        this.loadPermissions(row.unitguid);
      },
      loadPermissions(tenantId) {
        const _this = this;
        parameterMaintainList({
          isshow: 1,
          fiscalsysguid: 'moduleright',
          paragroup: 'other',
          tenantid: tenantId,
        }).then(response => {
          const list = response.data.obj;
          if (list && list.length > 0) {
            _this.permissionRecord = list[0];
            const paracontent = list[0].paracontent || '';
            const perms = paracontent.split(';').filter(p => p && p.trim());
            _this.selectedPermissions = perms;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      savePermissions() {
        const _this = this;
        if (!this.permissionRecord) {
          this.$message({ message: '权限配置记录不存在', type: 'warning' });
          return;
        }
        this.savingPermission = true;

        const existingContent = this.permissionRecord.paracontent || '';
        const existingPerms = existingContent.split(';').filter(p => p && p.trim());

        // 获取所有管理的权限key
        const allManagedKeys = [];
        this.permissionGroups.forEach(g => {
          g.permissions.forEach(p => allManagedKeys.push(p.key));
        });

        // 保留不在管理列表中的原有权限，合并新选中的权限
        const otherPerms = existingPerms.filter(p => !allManagedKeys.includes(p));
        const newPerms = [...otherPerms, ...this.selectedPermissions];

        // 构造paracontent（去重）
        const uniquePerms = [...new Set(newPerms)];
        const paracontent = ';' + uniquePerms.join(';') + ';';

        sysupdateparacontent({
          fiscalsysguid: 'moduleright',
          paragroup: 'other',
          paraname: this.permissionRecord.paraname,
          paracontent: paracontent,
          tenantid: this.currentTenantId,
        }).then(resp => {
          _this.savingPermission = false;
          if (resp.data.code == 0) {
            _this.$message({ message: '保存成功', type: 'success' });
            _this.permissionDialogVisible = false;
          } else {
            _this.$message({ message: resp.data.msg, type: 'error' });
          }
        }).catch((error) => {
          console.log(error);
          _this.savingPermission = false;
        });
      },
      //编辑
      handleEdit(index, row) {
        this.$refs.manageTenantEdit.initData(row.unitguid)
        this.$refs.manageTenantEdit.show()
      },
      bindGrid() {
        sysmanageList({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          tenantname: this.searchdata,
          isoverendtime: this.isoverendtime ? 1 : 0,
          isused: this.isoverendtime ? 0 : 1,
        }).then(response => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {
      this.bindGrid();
    },
    components: {
      ManageTenantEdit
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/sysmanage/managgetenant/ManageTenantList.vue